import { useQuery } from '@tanstack/react-query';
import { messagesApi } from '../lib/api';

export interface MessageRow {
  id: string;
  account_id: string;
  folder_id: string;
  uid: number;
  subject: string | null;
  from_address: string | null;
  from_name: string | null;
  received_at: string | null;
  sent_at: string | null;
  is_seen: boolean;
  is_flagged: boolean;
  is_answered: boolean;
  has_attachments: boolean;
  attachment_count: number;
  snippet: string | null;
  ai_summary: string | null;
  ai_priority: string | null;
  ai_category: string | null;
  thread_id: string | null;
  // Stato "Da rispondere": 'todo' = da rispondere, 'done' = risposto, null = nessuno.
  reply_status?: 'todo' | 'done' | null;
  // Tag associati al messaggio (aggiunti dalle regole/AI). Shape allineata al contratto shared.
  tags?: { id: string; name: string; color: string; icon?: string | null; kind?: 'normal' | 'badge' }[];
}

export function useMessages(params: {
  account_id?: string;
  folder_id?: string;
  search?: string;
  unread?: boolean;
}) {
  return useQuery({
    queryKey: ['messages', params],
    queryFn: async () => {
      const res = await messagesApi.list({ ...params, limit: 100 });
      return (res?.messages ?? []) as MessageRow[];
    },
  });
}

export function useMessage(id: string | null, includeBody = false) {
  return useQuery({
    queryKey: ['message', id, includeBody],
    queryFn: async () => {
      if (!id) return null;
      const res = await messagesApi.get(id, includeBody);
      return res?.message ?? null;
    },
    enabled: !!id,
  });
}
